/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Card_HiddenInputs */

const en_dr_room_card_hidden = /** @type {(inputs: Dr_Room_Card_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden card`)
};

const id_dr_room_card_hidden = /** @type {(inputs: Dr_Room_Card_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu tersembunyi`)
};

/**
* | output |
* | --- |
* | "Hidden card" |
*
* @param {Dr_Room_Card_HiddenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_card_hidden = /** @type {((inputs?: Dr_Room_Card_HiddenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Card_HiddenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_card_hidden(inputs)
	return en_dr_room_card_hidden(inputs)
});